import React from 'react';
import {
  UsersSection,
  TourOperatorsSection,
  DataProtectionAndManipulationSection,
  PrivacyPolicyAndDataProtectionSection,
} from './ContractSections';

const TermsAndConditionsLanding = () => {
  return (
    <React.Fragment>
      <UsersSection style={{ textAlign: 'justify' }} />
      <TourOperatorsSection style={{ textAlign: 'justify' }} />
      <PrivacyPolicyAndDataProtectionSection style={{ textAlign: 'justify' }} />
      <DataProtectionAndManipulationSection style={{ textAlign: 'justify' }} />
    </React.Fragment>
  );
};

export default TermsAndConditionsLanding;
